import { render, staticRenderFns } from "./CentroTrabajo.vue?vue&type=template&id=239921d9&"
import script from "./CentroTrabajo.vue?vue&type=script&lang=js&"
export * from "./CentroTrabajo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports